import { useIntl } from 'react-intl';
import { Engine } from '@rossum/api-client/engines';
import CopyToClipboardButton from '@rossum/components/copy-to-clipboard/CopyToClipboardButton';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Stack, Typography } from '@rossum/ui/material';
import { AutomationBreadcrumbs } from '../../../containers/Automation/AutomationBreadcrumbs';
import { automationEnginesPath } from '../../../containers/Automation/helpers';
import { engineBasicSettingsPath } from '../routes';
import { EngineSettingsTabs } from './EngineSettingsTabs';

type EngineQueueSettingsHeaderProps = {
  engine: Engine;
  isSaving: boolean;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const EngineQueueSettingsHeader = ({
  engine,
  isSaving,
  ...rest
}: EngineQueueSettingsHeaderProps) => {
  const intl = useIntl();

  return (
    <Header
      {...rest}
      breadcrumbs={
        <AutomationBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'components.appBar.menu.automation.aiEngines',
              }),
              to: automationEnginesPath(),
            },
            {
              label: engine.name,
              to: engineBasicSettingsPath(engine.id),
            },
            {
              label: intl.formatMessage({
                id: 'features.engines.header.tabs.settings.queues',
              }),
            },
          ]}
        />
      }
      tabs={<EngineSettingsTabs value="queue-settings" engineId={engine.id} />}
      title={engine.name}
      description={
        <Stack>
          <Typography variant="body2">
            {intl.formatMessage({
              id: 'features.engines.header.queueSettings.description',
            })}
          </Typography>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body2">
              {intl.formatMessage({
                id: 'features.engines.header.description.engineId',
              })}
              {': '}
            </Typography>
            <Typography variant="body2" color="text.primary">
              {engine.agendaId}
            </Typography>
            <CopyToClipboardButton
              content={`${engine.agendaId}`}
              iconColor="secondary"
            />
          </Stack>
        </Stack>
      }
    />
  );
};
